import { UserRoles } from '../../api/queries';
import { Routes } from '../../enums/Routes';
import { SafetyRepRolesUtils } from '../../utils/RolesUtils/SafetyRepRoles.utils';
import { TeamLeaderRolesUtils } from '../../utils/RolesUtils/TeamLeaderRoles.utils';

/**
 * Where the user's part of the app starts, the same place the login takes them. The team leader's dashboard is only
 * for those who lead a team (or the administrator); the others start in their own part, or with their notifications.
 */
export const startPageFor = (userRoles: ReadonlyArray<string>, leadsTeam = false): string => {
  if (userRoles.includes(UserRoles.HR_ADMIN)) return Routes.HRDashboard;
  if (userRoles.includes(UserRoles.PARTNER_ADMIN)) return Routes.PartnerAdmin;
  if (SafetyRepRolesUtils.isOnlySafetyRep(userRoles)) return Routes.SafetyRepOverview;
  if (TeamLeaderRolesUtils.hasTeamLeaderPart(userRoles, leadsTeam)) return Routes.Dashboard;
  if (userRoles.includes(UserRoles.SAFETY_REP)) return Routes.SafetyRepOverview;
  if (userRoles.includes(UserRoles.GENERAL_MANAGER)) return Routes.GeneralManagerTasks;
  return Routes.Notifications;
};
